import Kavling1 from "./kavling (1).webp";
import Kavling2 from "./kavling (2).webp";

const kavlinga = { Kavling1, Kavling2 };

export default kavlinga;
